export interface IAppConsts {
    readonly tenancyNamePlaceHolderInUrl: string;

    remoteServiceBaseUrl: string;
    remoteServiceBaseUrlFormat: string;
    appBaseUrl: string;
    appBaseHref: string;
    appBaseUrlFormat: string;
    recaptchaSiteKey: string;
    subscriptionExpireNootifyDayCount: number;

    localeMappings: any[];

    readonly userManagement: any;

    readonly localization: any;

    readonly authorization: any;

    readonly grid: any;

    readonly Routs: any;
}

export class SharedAppConsts implements IAppConsts {
    static instance(): IAppConsts {
        const windowStorageKy = 'IAppConsts';
        var instance = window[windowStorageKy];
        if (instance != null) {
            return instance;
        }

        instance = new SharedAppConsts();
        window[windowStorageKy] = instance;
        return instance;
    }
    private SharedAppConsts() {
    }

    tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

    remoteServiceBaseUrl: string = '';
    remoteServiceBaseUrlFormat: string = '';
    appBaseUrl: string = '';
    appBaseHref: string = ''; // returns angular's base-href parameter value if used during the publish
    appBaseUrlFormat: string = '';
    recaptchaSiteKey: string = '';
    subscriptionExpireNootifyDayCount: number = 30;

    localeMappings: any = [];

    readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    readonly localization = {
        defaultLocalizationSourceName: 'Ublion'
    };

    readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token'
    };

    readonly grid = {
        defaultPageSize: 10
    };

    readonly Routs = {
        EmailTemplates: 'email-templates',
        EmailTemplateList: '/app/email-templates',
    };
}

export class AppConsts {
    static tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

    static remoteServiceBaseUrl: string = '';
    static remoteServiceBaseUrlFormat: string = '';
    static appBaseUrl: string = '';
    static appBaseHref: string = ''; // returns angular's base-href parameter value if used during the publish
    static appBaseUrlFormat: string = '';
    static recaptchaSiteKey: string = '';
    static subscriptionExpireNootifyDayCount: number = 30;

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'Ublion'
    };

    static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token'
    };

    static readonly grid = {
        defaultPageSize: 10
    };


    static readonly Routs = {
        EmailTemplates: 'email-templates',
        EmailTemplateList: '/app/email-templates',
    };
}
